<template>
  <div class="container">
    <div
      class="nav-item"
      v-for="(item,index) in navList"
      :key="item.colmun_id"
      @click="toNewsList(item.colmun_id, index)"
      @mouseover="showSubNav = index"
      @mouseleave="showSubNav = ''"
    >
      <span :class="(index !== 0 && index === showSubNav) ?  'item-hover' : ''">{{item.title}}</span>

      <transition name="fade">
        <ul v-show="index !== 0 && index === showSubNav" class="sub-nav">
          <li v-for="list in subNavList[index]" :key="list.value" @click="toList(list)">{{list.label}}</li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import axios from 'axios'
import { orgId, requestUrl } from '../common/constant'

export default {
  props: {
    navList: {
      type: Array,
      required: true
    },
    subNavList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showSubNav: ''
    }
  },
  name: 'HomeNav',
  methods: {
    ...mapMutations([
      'updateMainColumnId'
    ]),
    toNewsList (columnId, index) {
      if (index === 0) {
        this.updateMainColumnId(0)
        window.location.href = 'http://www.scdnjt.com'
      }
    },
    async toList (column) {
      if (column.label === 'ＯＡ内网') {
        window.open('http://192.168.1.80')
      } else if (column.label === 'ＯＡ外网') {
        window.open('https://vpn.cmjt.com.cn/')
      } else if (column.label === '管理平台') {
        window.open('http://oa.scdnjt.com/')
      } else if (column.label === '效能考核管理平台') {
        window.open('http://125.64.218.31:33520/seeyon/main.do')
      } else if (column.label === '投稿专用') {
        window.open('http://www.scdnjt.com/admin')
      } else if (column.type === 'channel') {
        this.$router.push({
          path: `/news/${column.value}`
        })
        this.updateMainColumnId(column.value)
      } else {
        const result = await axios.get(`${requestUrl}/news/article?id=${column.value}&orgId=${orgId}`)
        const articleId = result.data[0].id
        this.$router.push({
          path: `/content/${articleId}`
        })
      }
    }
  }
}
</script>

<style scoped>
  .container {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    background-color: rgb(0, 50, 88);
  }

  .nav-item {
    height: 100%;
    width: 100%;
    font-family: '黑体';
    font-size: 18px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    transition: all .5s;
  }

  .sub-nav {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background-color: rgb(7, 90, 154);
    color: #fff;
    z-index: 999;
    box-sizing: border-box;
  }

  .sub-nav li {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    padding: 14px 0;
    text-align: center;
  }

  .sub-nav li:hover {
    color: red;
    cursor: pointer;
  }

  .nav-item:hover {
    cursor: pointer;
    background-color: rgb(7, 90, 154);
    background: url("../../public/imgs/nav-head-a.png") no-repeat;
    background-size: cover;
    color: red;
    font-size: 20px;
    transition: all .5s;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .item-hover {
    font-weight: bold;
    margin-left: 20%;
  }
</style>
